const translations = {
  en: {
    dashboard: 'Dashboard',
    myResults: 'My Results',
    sequences: 'Sequences',
    recentActivity: 'Recent Activity',
    myApprovals: 'My Approvals',
    messages: 'Messages',
    contacts: 'Contacts',
    calls: 'My Calls',
    reports: 'My Reports',
    invoices: 'My Invoices',
    zainab: 'Zainab AI',
    referrals: 'Refer & Earn',
    help: 'Help',
    settings: 'Settings',
    signOut: 'Sign Out',
    welcomeBack: 'Welcome back',
    totalContacts: 'Total Contacts',
    activeSequences: 'Active Sequences',
    emailsSent: 'Emails Sent',
    smsSent: 'SMS Sent',
    revenueRecovered: 'Revenue Recovered',
    notifications: 'Notifications',
    markAllRead: 'Mark all read',
  },
  ar: {
    dashboard: 'لوحة التحكم',
    myResults: 'نتائجي',
    sequences: 'التسلسلات',
    recentActivity: 'النشاط الأخير',
    myApprovals: 'موافقاتي',
    messages: 'الرسائل',
    contacts: 'جهات الاتصال',
    calls: 'مكالماتي',
    reports: 'تقاريري',
    invoices: 'فواتيري',
    zainab: 'زينب AI',
    referrals: 'الإحالة والكسب',
    help: 'المساعدة',
    settings: 'الإعدادات',
    signOut: 'تسجيل الخروج',
    welcomeBack: 'مرحباً بعودتك',
    totalContacts: 'إجمالي جهات الاتصال',
    activeSequences: 'التسلسلات النشطة',
    emailsSent: 'الرسائل المُرسلة',
    smsSent: 'رسائل SMS المُرسلة',
    revenueRecovered: 'الإيراد المسترد',
    notifications: 'الإشعارات',
    markAllRead: 'تمييز الكل كمقروء',
  },
};

export const t = (key, lang = 'en') => translations[lang]?.[key] || translations.en[key] || key;
export default translations;
